import { render, staticRenderFns } from "./TreatmentSketchService.vue?vue&type=template&id=7cc2b54d&scoped=true&"
import script from "./TreatmentSketchService.vue?vue&type=script&lang=js&"
export * from "./TreatmentSketchService.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSketchService.vue?vue&type=style&index=0&id=7cc2b54d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc2b54d",
  null
  
)

export default component.exports